import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4d9968a8&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=4d9968a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9968a8",
  null
  
)

export default component.exports